/**
 * Função utilitária para validar se um valor é um email válido.
 *
 * @param email - Valor a ser validado
 * @returns {boolean} - Retorna true se o valor for um email válido, caso contrário retorna false  
 */
export const isEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

/**
 * Função utilitária para validar se um valor é um número de telefone válido.
 * Aceita números de telefone com ou sem o código do país (+), contendo entre 10 e 15 dígitos.
 *
 * @param phone - Valor a ser validado como número de telefone
 * @returns {boolean} - Retorna true se o valor for um número de telefone válido, caso contrário retorna false
 */
export const isPhone = (phone) => /^\+?\d{10,15}$/.test(phone);

const digitosDe = (valor) => String(valor || '').replace(/\D/g, '');
const todosIguais = (digitos) => /^(\d)\1+$/.test(digitos);

/**
 * CPF com os dois dígitos verificadores conferidos. Recusa os 11 dígitos iguais, como o app-empresas.
 */
export const isCpf = (valor) => {
    const n = digitosDe(valor);
    if (n.length !== 11 || todosIguais(n)) return false;
    const dv = (tamanho) => {
        const soma = n.slice(0, tamanho).split('').reduce((total, digito, i) => total + Number(digito) * (tamanho + 1 - i), 0);
        const resto = (soma * 10) % 11;
        return resto === 10 ? 0 : resto;
    };
    return dv(9) === Number(n[9]) && dv(10) === Number(n[10]);
};

/**
 * CNPJ com os dois dígitos verificadores conferidos. Recusa os 14 dígitos iguais, como o app-empresas.
 */
export const isCnpj = (valor) => {
    const n = digitosDe(valor);
    if (n.length !== 14 || todosIguais(n)) return false;
    const dv = (tamanho) => {
        const pesos = tamanho === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
        const resto = pesos.reduce((total, peso, i) => total + peso * Number(n[i]), 0) % 11;
        return resto < 2 ? 0 : 11 - resto;
    };
    return dv(12) === Number(n[12]) && dv(13) === Number(n[13]);
};

// O documento da empresa é um CPF (11 dígitos) ou um CNPJ (14), sempre com os dígitos verificadores (BBF-148).
export const isCpfOuCnpj = (valor) => isCpf(valor) || isCnpj(valor);
